module.exports = __webpack_public_path__ + "static/img/ic_gy_d_c@2x.5e21c6cd.png";